export default __webpack_public_path__ + "static/media/dummy_pdf_pdf2Data.ab8b9469.pdf";